import styled from 'styled-components';
import {flexFixedSizeItem} from "../../../../themes/architecture/css-helpers/flex";

export const JackpotBetWidgetPCWrapperDefaultBox = styled.div`
    ${flexFixedSizeItem};
    margin: 0rem 1rem 1rem 1rem;
    align-self: stretch;
    max-width: 36rem;
    width: calc(100% / 3);
    height: 40rem;
    min-height: 297px;
    max-height: 33rem;
`;
